import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "height100 d-flex justify-center align-center",
  style: {"min-height":"100vh"}
}
const _hoisted_2 = {
  key: 2,
  class: "height100 d-flex justify-center align-center text-center"
}
const _hoisted_3 = { style: {"white-space":"nowrap","font-size":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    class: "app_wrapper no-scroll-bar",
    id: "app"
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "top_safe_area" }, null, -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "#EE6090",
              size: "50"
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_main, {
            key: 1,
            class: "main_wrapper no-scroll-bar"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_vue_loading, {
              type: "bars",
              color: "#EE6090",
              size: { width: '50px', height: '50px' }
            })
          ])),
      (!_ctx.loading && _ctx.bottomNavActive)
        ? (_openBlock(), _createBlock(_component_v_bottom_navigation, {
            key: 3,
            class: "bottom_nav",
            app: "",
            grow: "",
            color: "primary",
            modelValue: _ctx.bottomNavValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bottomNavValue) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
                return (_openBlock(), _createBlock(_component_v_btn, {
                  key: menu.title,
                  onClick: ($event: any) => (_ctx.urlReplace(menu.url)),
                  disabled: menu.isDisabled,
                  value: menu.url,
                  height: "56"
                }, {
                  default: _withCtx(() => [
                    (menu.isImage)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["nav-icon", { 'active-icon': String(_ctx.bottomNavValue) === String(menu.url) }]),
                          style: _normalizeStyle({ '--icon-url': `url(${menu.icon})` })
                        }, null, 6))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          size: "20"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(menu.icon), 1)
                          ]),
                          _: 2
                        }, 1024)),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(menu.title), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}